// 販売期間用の開始時間リスト（00:00-23:00）
export const SALE_START_TIME_LIST = [
	{ key: "00:00", value: "00:00" },
	{ key: "01:00", value: "01:00" },
	{ key: "02:00", value: "02:00" },
	{ key: "03:00", value: "03:00" },
	{ key: "04:00", value: "04:00" },
	{ key: "05:00", value: "05:00" },
	{ key: "06:00", value: "06:00" },
	{ key: "07:00", value: "07:00" },
	{ key: "08:00", value: "08:00" },
	{ key: "09:00", value: "09:00" },
	{ key: "10:00", value: "10:00" },
	{ key: "11:00", value: "11:00" },
	{ key: "12:00", value: "12:00" },
	{ key: "13:00", value: "13:00" },
	{ key: "14:00", value: "14:00" },
	{ key: "15:00", value: "15:00" },
	{ key: "16:00", value: "16:00" },
	{ key: "17:00", value: "17:00" },
	{ key: "18:00", value: "18:00" },
	{ key: "19:00", value: "19:00" },
	{ key: "20:00", value: "20:00" },
	{ key: "21:00", value: "21:00" },
	{ key: "22:00", value: "22:00" },
	{ key: "23:00", value: "23:00" },
] as const;

// 販売期間用の終了時間リスト（00:00-23:59）
export const SALE_END_TIME_LIST = [
	{ key: "00:00", value: "00:00" },
	{ key: "01:00", value: "01:00" },
	{ key: "02:00", value: "02:00" },
	{ key: "03:00", value: "03:00" },
	{ key: "04:00", value: "04:00" },
	{ key: "05:00", value: "05:00" },
	{ key: "06:00", value: "06:00" },
	{ key: "07:00", value: "07:00" },
	{ key: "08:00", value: "08:00" },
	{ key: "09:00", value: "09:00" },
	{ key: "10:00", value: "10:00" },
	{ key: "11:00", value: "11:00" },
	{ key: "12:00", value: "12:00" },
	{ key: "13:00", value: "13:00" },
	{ key: "14:00", value: "14:00" },
	{ key: "15:00", value: "15:00" },
	{ key: "16:00", value: "16:00" },
	{ key: "17:00", value: "17:00" },
	{ key: "18:00", value: "18:00" },
	{ key: "19:00", value: "19:00" },
	{ key: "20:00", value: "20:00" },
	{ key: "21:00", value: "21:00" },
	{ key: "22:00", value: "22:00" },
	{ key: "23:00", value: "23:00" },
	{ key: "23:59", value: "23:59" },
] as const;
